import actionTypes from './holidayActionType'
import { ACCOUNT } from '../Account'

const initialState = {
  listHoliday: [],
  sideBarHolidays: [],
}

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SAVE_LIST_ALL_HOLIDAY:
      return {
        ...state,
        listHoliday: action.data
      }

    case ACCOUNT.actionType.CLEAR_ALL_DATA:
      return {
        ...initialState
      }

    case actionTypes.SAVE_SIDE_BAR_HOLIDAYS:
      return {
        ...state,
        sideBarHolidays: action.data,
      }

    default:
      return state
  }
}
